export enum AcknowledgementMethod {
    Email,
    Postal,
}